import { axios } from "./request";
axios.defaults.withCredentials = true;
import Vue from "vue";
const api = {
  baseApi: {
    //服务
    manage: "/simulator/manage",
  },
  createUrl(params) {
    return api.baseApi[params.service] + "/" + params.src;
  },
  commonBaseRule: {
    user: function (service, parameter, config, src, responseType) {
      var params = {
        service,
        src,
      };
      return {
        url: api.createUrl(params),
        method: "post",
        data: parameter,
        responseType,
        headers: {
          config: config,
        },
      };
    },
    nolimit: function (service, parameter, config, src, method, responseType) {
      var params = {
        service,
        src,
      };
      let paramsStr = method == "get" ? "params" : "data";
      let nolimit = {
        url: api.createUrl(params),
        method: method,
        responseType,
        headers: {
          config: config,
        },
      };
      nolimit[paramsStr] = parameter;
      return nolimit;
    },
    imgnolimit: function (
      service,
      parameter,
      config,
      method,
      src,
      responseType
    ) {
      var params = {
        service,
        src,
      };
      let paramsStr = method == "get" ? "params" : "data";
      let nolimit = {
        url: api.createUrl(params),
        method: method,
        responseType: "arraybuffer",
        headers: {
          config: config,
        },
      };
      nolimit[paramsStr] = parameter;
      return nolimit;
    },
    list: function (service, parameter, config, src, responseType) {
      var params = {
        service,
        src,
      };
      return {
        url: api.createUrl(params) + "",
        method: "get",
        params: parameter,
        responseType,
        headers: {
          config: config,
        },
      };
    },
    nopage: function (service, parameter, config, src, responseType) {
      var params = {
        service,
        src,
      };
      return {
        url: api.createUrl(params) + "/nopage",
        method: "get",
        params: parameter,
        responseType,
        headers: {
          config: config,
        },
      };
    },
    enum: function (service, parameter, config, src, responseType) {
      var params = {
        service,
        src,
      };
      return {
        url: api.createUrl(params) + "/enum",
        method: "get",
        params: parameter,
        responseType,
        headers: {
          config: config,
        },
      };
    },
    postdataAllUrl: function (service, parameter, config, src) {
      var params = {
        service,
        src,
      };
      return {
        url: api.createUrl(params) + "",
        method: "post",
        data: parameter,
        headers: {
          config: config,
        },
      };
    },
    getByID: function (service, parameter, config, src, responseType) {
      var id = parameter.id;
      //id为空时，传null
      if (!(id || id === 0)) {
        id = "null";
      }
      var params = {
        service,
        src,
      };
      return {
        url: api.createUrl(params) + "/" + id,
        method: "get",
        responseType,
        headers: {
          config: config,
        },
      };
    },
    save: function (service, parameter, config, src, responseType) {
      var params = {
        service,
        src,
      };
      return {
        url: api.createUrl(params) + "/save",
        method: "post",
        data: parameter,
        responseType,
        headers: {
          config: config,
        },
      };
    },
    update: function (service, parameter, config, src, responseType) {
      var params = {
        service,
        src,
      };
      return {
        url: api.createUrl(params) + "/update",
        method: "post",
        data: parameter,
        responseType,
        headers: {
          config: config,
        },
      };
    },
    del: function (service, parameter, config, src, responseType) {
      var params = {
        service,
        src,
      };
      var ids = parameter.ids;
      //id为空时，传null
      if (!(ids || ids === 0)) {
        ids = "null";
      }
      return {
        url: api.createUrl(params) + "/del",
        method: "get",
        params: parameter,
        responseType,
        headers: {
          config: config,
        },
      };
    },
  },
};
//传参形式 params:{type,service,parameter,config}
//type:调用形式
// service:模块名
// parameter:参数
// config:配置
let sendHttp = {
  commonRest(params) {
    params.responseType = params.responseType ? params.responseType : "text";
    const {
      service,
      parameter,
      config = config || { loading: false },
      type,
      src,
      method,
      responseType = responseType || "text",
    } = params;
    return axios(
      api.commonBaseRule[type](
        service,
        parameter,
        config,
        src,
        method,
        responseType
      )
    );
  },
  // 列表查询
  commonRestList(params) {
    params.responseType = params.responseType ? params.responseType : "text";
    const {
      service,
      parameter,
      src,
      config = config || { loading: false },
      responseType = responseType || "text",
    } = params;
    return axios(
      api.commonBaseRule["list"](service, parameter, config, src, responseType)
    );
  },
  // 无后缀查询
  commonRestListNolimit(params) {
    params.responseType = params.responseType ? params.responseType : "text";
    const {
      service,
      parameter,
      config = config || { loading: false },
      src,
      method = method || "get",
      responseType = responseType || "text",
    } = params;
    return axios(
      api.commonBaseRule["nolimit"](
        service,
        parameter,
        config,
        src,
        method,
        responseType
      )
    );
  },
  // // 无后缀查询
  commonRestImgNolimit(params) {
    params.responseType = params.responseType ? params.responseType : "text";
    const {
      service,
      parameter,
      config = config || { loading: false },
      src,
      method = method || "get",
      responseType = responseType || "text",
    } = params;
    return axios(
      api.commonBaseRule["imgnolimit"](service, parameter, config, method, src)
    );
  },
  // 无分页列表查询
  commonRestListNopage(params) {
    params.responseType = params.responseType ? params.responseType : "text";
    const {
      service,
      parameter,
      src,
      config = config || { loading: false },
      responseType = responseType || "text",
    } = params;
    return axios(
      api.commonBaseRule["nopage"](
        service,
        parameter,
        config,
        src,
        responseType
      )
    );
  },
  // 业务数据枚举查询
  commonRestListEnum(params) {
    params.responseType = params.responseType ? params.responseType : "text";
    const {
      service,
      parameter,
      src,
      config = config || { loading: false },
      responseType = responseType || "text",
    } = params;
    return axios(
      api.commonBaseRule["enum"](service, parameter, config, src, responseType)
    );
  },
  // 根据id查询
  commonRestGetByID(params) {
    params.responseType = params.responseType ? params.responseType : "text";
    const {
      service,
      parameter,
      src,
      config = config || { loading: false },
      responseType = responseType || "text",
    } = params;
    return axios(
      api.commonBaseRule["getByID"](
        service,
        parameter,
        config,
        src,
        responseType
      )
    );
  },
  // 保存
  commonRestSave(params) {
    params.responseType = params.responseType ? params.responseType : "text";
    const {
      service,
      parameter,
      src,
      config = config || { loading: false },
      responseType = responseType || "text",
    } = params;
    return axios(
      api.commonBaseRule["save"](service, parameter, config, src, responseType)
    );
  },
  // 更新
  commonRestUpdate(params) {
    params.responseType = params.responseType ? params.responseType : "text";
    const {
      service,
      parameter,
      src,
      config = config || { loading: false },
      responseType = responseType || "text",
    } = params;
    return axios(
      api.commonBaseRule["update"](
        service,
        parameter,
        config,
        src,
        responseType
      )
    );
  },
  // 删除
  commonRestDel(params) {
    params.responseType = params.responseType ? params.responseType : "text";
    const {
      service,
      parameter,
      src,
      config = config || { loading: false },
      responseType = responseType || "text",
    } = params;
    return axios(
      api.commonBaseRule["del"](service, parameter, config, src, responseType)
    );
  },
};
Vue.prototype.$httpReq = sendHttp;
export default sendHttp;



//////////////////
// WEBPACK FOOTER
// ./proxy/apiMap.js
// module id = null
// module chunks = 